import { Injectable } from '@angular/core';

import { combustiveisStorage } from "./data.service";
import { tanquesStorage } from "../../tanques/shared/data.service";
import { TanqueService } from "../../tanques/shared/tanque.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { TanqueNavigationService } from "../../tanques/shared/tanque-navigation.service";

@Injectable()
export class CombustivelService {

    constructor(
        private _autocompleteService: AutoCompleteService,
        private _tanqueService: TanqueService,
        private _tanqueNavigationService: TanqueNavigationService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(combustiveisStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(combustiveisStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(combustiveisStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        if(Response) {
            var otherFormObject: any;

            if (otherForm === tanquesStorage) {
                otherFormObject = this._tanqueService.getSessionStorage();
                otherFormObject.combustivel = Response;
                this._tanqueService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(combustiveisStorage);

        if (otherForm === tanquesStorage) {
            otherFormObject = this._tanqueService.getSessionStorage();
            if (otherFormObject.id) {
                this._tanqueNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._tanqueNavigationService.goToNew();
            }
        }

    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/shared/combustivel.service.ts
 **/